// Copyright (c) StrangeBee 2023

import client from '@Client';
import { useLocalMessage } from '@Helpers/locale';
import { handleNotificationError, openMessage } from '@Helpers/notification';
import { computeEventList } from '@Organisms/AccountDetails/eventList';
import { LoginPasswordReset } from '@Organisms/Login/LoginPasswordReset/LoginPasswordReset';
import { LoginSider } from '@Organisms/Login/LoginSider/LoginSider';
import { useGenericQuery } from '@Queries/genericQueries';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import { Layout } from 'antd';
import React, { ReactElement, useCallback, useMemo } from 'react';
import { BrandingParams } from 'thehive-sdk';

const SendPasswordReset = (): ReactElement => {
    const i = useLocalMessage();

    const eventList = useMemo(
        () =>
            computeEventList({
                controller: client.AuthController,
                onSuccess: (count, message) => {
                    if (message) {
                        openMessage('success', message);
                    }
                },
                onError: handleNotificationError,
                locale: i,
            }),
        [i],
    );

    const { data: brandingData } = useGenericQuery<BrandingParams>({
        fetchOnStart: true,
        manual: true,
        retry: false,
        key: ['branding-props'],
        fetchCallback: useCallback(() => client.BrandingController.list(), []),
    });

    return (
        <Layout className="login-layout" key="login">
            <LoginSider src={brandingData?.loginLogo} />
            <LoginPasswordReset eventList={eventList} />
        </Layout>
    );
};

export const Route: RouteType = {
    path: RouteBuilder.compute('login.reset'),
    content: <SendPasswordReset />,
    exact: true,
};
